/**
 * useSaveShortcut Hook
 * Handles CTRL+S / CMD+S keyboard shortcut to trigger a save action
 */

import { useEffect, useCallback } from 'react';

/**
 * Custom hook to handle CTRL+S / CMD+S save shortcut
 * @param {Function} onSave - Callback function when CTRL+S is pressed
 * @param {boolean} enabled - Whether the shortcut is enabled (default: true)
 */
const useSaveShortcut = (onSave, enabled = true) => {
  const handleKeyDown = useCallback((event) => {
    const key = event.key?.toLowerCase();
    if ((event.ctrlKey || event.metaKey) && key === 's') {
      event.preventDefault();
      event.stopPropagation();
      onSave();
    }
  }, [onSave]);

  useEffect(() => {
    if (!enabled) return;
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown, enabled]);
};

export default useSaveShortcut;
